import {
  type OnlyFansMessage,
  type OnlyFansMessageMedia,
  SendMessageRequest,
  type VaultMediaFilesDto,
  VaultMediaType,
} from '@api'

import { $vaultMediasMap } from '@/models/vault/medias'
import { $cloneToOriginalRegistry } from '@/models/vault/medias/clonned'

import type { Message, MessageSendRequest, SendMessageParams } from '../types'

export const buildOptimisticMessage = ({
  id,
  messageBody,
  creatorId,
}: {
  id: number
  messageBody: Partial<MessageSendRequest>
  creatorId: number
}): Message => {
  let media: OnlyFansMessageMedia[] = []

  if (messageBody.mediaFiles?.length) {
    // eslint-disable-next-line effector/no-getState
    const cloneToOriginalRegistry = $cloneToOriginalRegistry.getState()
    // eslint-disable-next-line effector/no-getState
    const vaultMediasMap = $vaultMediasMap.getState()

    // show thumbnail during media processing
    // @ts-ignore
    media = messageBody.mediaFiles
      .map((mediaFile, index) => {
        if (typeof mediaFile === 'number') {
          const mediaId = cloneToOriginalRegistry.has(mediaFile)
            ? cloneToOriginalRegistry.get(mediaFile)!
            : mediaFile

          return vaultMediasMap[mediaId] || null
        }
        const thumbUrl = mediaFile.thumbs?.[0]?.url

        if (!thumbUrl) {
          return null
        }

        return {
          files: {
            thumb: { url: thumbUrl },
            full: {},
          } as VaultMediaFilesDto,
          type: VaultMediaType.PHOTO,
          isPreview: true,
          duration: 0,
          canView: false,
          id: index,
          hasCustomPreview: false,
          locked: false,
          hasError: false,
        }
      })
      .filter(Boolean)
  }

  return {
    ...messageBody,
    media,
    fromUser: { id: creatorId },
    createdAt: new Date().toISOString(),
    isFree: messageBody.price === 0 || messageBody.price === undefined,
    _isTempMessage: true,
    id,
  } as Message
}

export const formatMessageMedia = (
  message: SendMessageParams['message'],
): SendMessageRequest => {
  const { mediaFiles, ...rest } = message

  if (!mediaFiles?.length) {
    // @ts-ignore
    return message
  }
  const formattedMediaFiles = mediaFiles.map((item) => {
    if (typeof item === 'number') {
      return item
    }
    const { thumbs, isPreview, ...file } = item

    // for uploaded media we send an object, but in miss in swagger types
    return file
  })

  return {
    ...rest,
    // @ts-ignore
    mediaFiles: formattedMediaFiles,
  }
}
